import { gql } from '@apollo/client';

import { PAGE_INFO_FIELDS } from './fields';

export const GET_APPLICATION_NEW_COUNT = gql`
  query ApplicationNewCount($profile: ProfileEnum!) {
    jobApplications(profile: $profile, first: 1) {
      companyTabs {
        newCount
      }
    }
  }
`;

// The field arguments deliberately mirror GET_JOB_APPLICATIONS: identical
// arguments mean the same cache entry, so this writes fresh counters over the
// list without touching the pages fetchMore has already loaded.
export const GET_APPLICATION_TABS = gql`
  query ApplicationTabs(
    $profile: ProfileEnum!
    $first: Int
    $status: JobApplicationStatusesEnum
    $candidateStatus: JobApplicationCandidateStatusesEnum
    $vacancyId: ID
  ) {
    jobApplications(
      profile: $profile
      first: $first
      status: $status
      candidateStatus: $candidateStatus
      vacancyId: $vacancyId
    ) {
      totalCount
      companyTabs {
        activeCount
        archivedCount
        interviewCount
        newCount
        offerCount
        readCount
        rejectedCount
        selectedCount
        workCount
      }
      candidateTabs {
        activeCount
        interviewCount
        newCount
        offerCount
        readCount
        rejectedCount
        workCount
      }
    }
  }
`;

export const JOB_APPLICATION_FIELDS = gql`
  fragment JobApplicationFields on JobApplication {
    id
    fullName
    body
    fileUrl
    filename
    link
    createdAt
    resumeDisabled
    candidateStatus
    companyStatus
    events {
      id
      createdAt
      status
      title
      description
    }
    candidate {
      id
      name
      email
      phones
      logoUrl
    }
    resume {
      id
      positionName
    }
    vacancy {
      id
      positionName
      status
      daysLeft
      category {
        id
        name
      }
      profile {
        ... on Company {
          id
          name
          logoUrl
        }
      }
    }
  }
`;

export const GET_JOB_APPLICATION = gql`
  ${JOB_APPLICATION_FIELDS}

  query JobApplication($profile: ProfileEnum!, $id: ID!) {
    jobApplications(profile: $profile, id: $id, first: 1) {
      nodes {
        ...JobApplicationFields
      }
    }
  }
`;

export const GET_JOB_APPLICATIONS = gql`
  ${PAGE_INFO_FIELDS}
  ${JOB_APPLICATION_FIELDS}

  query JobApplications(
    $profile: ProfileEnum!
    $after: String
    $first: Int
    $status: JobApplicationStatusesEnum
    $candidateStatus: JobApplicationCandidateStatusesEnum
    $vacancyId: ID
  ) {
    jobApplications(
      profile: $profile
      after: $after
      first: $first
      status: $status
      candidateStatus: $candidateStatus
      vacancyId: $vacancyId
    ) {
      totalCount
      filterableVacancies {
        id
        positionName
      }
      companyTabs {
        activeCount
        archivedCount
        interviewCount
        newCount
        offerCount
        readCount
        rejectedCount
        selectedCount
        workCount
      }
      candidateTabs {
        activeCount
        interviewCount
        newCount
        offerCount
        readCount
        rejectedCount
        workCount
      }
      pageInfo {
        ...pageInfoFields
      }
      nodes {
        ...JobApplicationFields
      }
    }
  }
`;

export const GET_APPLICATION_RESUME = gql`
  query ApplicationResume($id: ID!) {
    resume(id: $id) {
      id
      name
      logo
      positionName
      salaryFrom
      salaryTo
      location
      education
      educationInfo
      experience
      experienceInfo
      description
      personal
      skills
      profile {
        id
        age
        logoUrl
      }
    }
  }
`;
